import React from 'react';

import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import PageLayout from '@fd/ui/Layout';
import Tabs from '@fd/ui/Tabs';

// Import tab components
import AppSettings from './tabs/AppSettings';
import AppStoreConfigurationTab from './tabs/AppStoreConfigurationTab';
import BuildTab from './tabs/BuildTab';
import GooglePlayConfigurationTab from './tabs/GooglePlayConfigurationTab';

type Props = MappedState;

const MobileAppsConfiguration = ({ translate, appId }: Props) => {
  const tabItems = [
    {
      label: translate('App_Settings') as string,
      queryString: 'app-settings',
      component: <AppSettings />,
    },
    {
      label: translate('App_Store_Configuration') as string,
      queryString: 'app-store',
      component: <AppStoreConfigurationTab />,
    },
    {
      label: translate('Google_Play_Configuration') as string,
      queryString: 'google-play',
      component: <GooglePlayConfigurationTab />,
    },
    {
      label: 'Start Builds',
      queryString: 'start-builds',
      component: <BuildTab />,
    },
  ];

  return (
    <PageLayout
      documentTitle="Mobile_Apps_Configuration"
      title={translate('Mobile_Apps_Configuration')}
      strictToParent
      toParent={`/${appId}/sales-channels/mobile-apps?tab=settings`}
    >
      <Tabs tabItems={tabItems} />
    </PageLayout>
  );
};

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => ({
  appId: state.currentApp?.AppId,
  translate: getTranslate(state),
});

export default connect(mapStateToProps)(MobileAppsConfiguration);
